/*
 * Project: BookingEngine
 * Module: components/icons/highlights/SizeIcon.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';

const ServiceIcon = () => (
  <svg className="svg-icon highlight-size-icon" width="29px" height="28px" viewBox="0 0 29 28" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/facilities/size" transform="translate(-6.000000, -6.000000)">
        <g id="Group-2" transform="translate(6.000000, 6.000000)">
          <path d="M0,4 L2,4 L25,27 L25,28 L0,28 L0,4 Z M6,17 L6,23 L12,23 L6,17 Z" fill="#B8E986"/>
          <rect fill="#000000" style={{ mixBlendMode: 'overlay' }} opacity="0.600000024"
                x="0" y="4" width="1" height="24" />
          <polygon fill="#000000" style={{ mixBlendMode: 'overlay' }} opacity="0.600000024"
                   points="6 15 14 23 12 23 6 17" />
          <polygon fill="#FFFFFF" opacity="0.400000006" points="2 4 25 27 20 27 2 9" />
          <polygon fill="#F19E1E" points="8 0 9 1 8 2 27 21 28 20 29 21 26 24 25 23 26 22 7 3 6 4 5 3" />
          <g id="Group" transform="translate(3.000000, 6.000000)" fill="#18BAB7">
            <polygon points="1 0 2 1 1 2 0 2 0 1" />
            <polygon points="3 2 4 3 3 4 2 4 2 3" />
            <polygon points="5 4 6 5 5 6 4 6 4 5" />
            <polygon points="7 6 8 7 7 8 6 8 6 7" />
            <polygon points="9 8 10 9 9 10 8 10 8 9" />
            <polygon points="11 10 12 11 11 12 10 12 10 11" />
            <polygon points="13 12 14 13 13 14 12 14 12 13" />
            <polygon points="15 14 16 15 15 16 14 16 14 15" />
            <polygon points="17 16 18 17 17 18 16 18 16 17" />
            <polygon points="19 18 20 19 19 20 18 20 18 19" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ServiceIcon;
